const mq = window.matchMedia('(max-width: 767px)');
let observer = null; 

function checkForAtcMobile() {
  const atcTarget = document.querySelector('#AddToCart');
  const stickyForm = document.querySelector('product-sticky-form');

  if (!atcTarget || !stickyForm) return;

  // If screen is mobile
  if (mq.matches) {

    // Create observer only once
    if (!observer) {
      observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              stickyForm.setAttribute('hidden', true);
            } else {
              stickyForm.removeAttribute('hidden');
            }
          });
        },
        {
          root: null,
          rootMargin: '0px',
          threshold: 0.1,
        }
      );

      observer.observe(atcTarget);
    }
  } else {
   
    if (observer) {
      observer.disconnect();
      observer = null;
    }
   // stickyForm.removeAttribute('hidden'); 
  }
}

window.addEventListener('load', checkForAtcMobile);
window.addEventListener('scroll', checkForAtcMobile);
window.addEventListener('resize', checkForAtcMobile);
mq.addEventListener('change', checkForAtcMobile);
checkForAtcMobile();


document.addEventListener('DOMContentLoaded', function() {
  
  var shopifySectionApps = document.querySelector('.shopify-section--apps');

  if (shopifySectionApps) {
    var observer = new MutationObserver(function(mutationsList) {
      mutationsList.forEach(function(mutation) {
        var noReviews = shopifySectionApps.querySelector('.junip-no-reviews');
        if (noReviews) {
          shopifySectionApps.style.display = 'none';
          observer.disconnect();
        }
      });
    });

    observer.observe(shopifySectionApps, {
      childList: true,
      subtree: true
    });
  }

});

